/**
 * Bug #518
 * @Author Liya BAby
 * @Date 27 Jul 2021
 */
// import { PatientDashboardPath } from "config/constants"
import {  Appointment } from "config/routersConstants"
/**
 * Bug #438
 * @Author Anupama P
 * @Date 1 Jul 2021
 */
export const PublicMenuList = [
  // { id: 1, to: Homes.path, icon: 'fa-home', label: Homes.label, unreadCount: 0, menuParentId: 0, type: 0, auth: true },
  // { id: 2, to: PatientDashboardPath, icon: 'fa-columns', label: 'My Dashboard', unreadCount: 0, menuParentId: 0, type: 1 },
  { id: 3, to: Appointment.path, icon: 'fa-calendar-check', label: 'Appointments', unreadCount: 0, menuParentId: 0, type: 2, auth: true },
  // { id: 5, to: Blog.path, icon: 'fa-blog', label: Blog.label, unreadCount: 0, menuParentId: 0, type: 0, auth: true  },
]
/** End */